import React, { useState, useEffect, useRef } from 'react';
import { Users, BookOpen, X, Search, AlertCircle, Check, Info, BarChart3, Plus, Trash2, UserCheck, GraduationCap, Clock, Star, ChevronDown, ChevronRight, Baby, School, Building, BookOpen as BookOpenIcon, User } from 'lucide-react';
import { api } from '../services/api';
import { Toast } from '../components/ui/Toast';
import { LongToast, shouldUseLongToast } from '../components/ui/LongToast';
import { Button } from './ui/button';
import ConfirmDialog from './ConfirmDialog';
import LoadingSpinner from './LoadingSpinner';
import { Card, CardTitle } from './ui/card';


const TeacherClassAssignment = () => {
  // ÃÂtats existants (conservÃÂ©s)
  const [teachers, setTeachers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [hourlyPendingAssignments, setHourlyPendingAssignments] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [activeYear, setActiveYear] = useState(null);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    teacher: null,
    class: null,
    type: '',
    description: '',
    subjects: [],
    assignmentId: null,
    subject: null
  });

  const [toastInfo, setToastInfoState] = useState(null);
  const [statistics, setStatistics] = useState(null);

  // Nouveaux ÃÂ©tats pour la gestion intelligente
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'principals', 'subjects'
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [availableSubjects, setAvailableSubjects] = useState([]);
  const [teacherRoles, setTeacherRoles] = useState({});
  // Nouveaux ÃÂ©tats pour la gestion des sections
  const [sections, setSections] = useState([]);
  const [expandedSections, setExpandedSections] = useState(new Set());

  // Ajouter ces ÃÂ©tats aprÃÂ¨s les autres
  const [teacherPage, setTeacherPage] = useState(1);
  const [teachersPerPage] = useState(5);

  const [selectedSection, setSelectedSection] = useState('');
  const [sectionSearchTerm, setSectionSearchTerm] = useState('');
  const [isSectionDropdownOpen, setIsSectionDropdownOpen] = useState(false);
  const [classSearchTerm, setClassSearchTerm] = useState('');
  const [isClassDropdownOpen, setIsClassDropdownOpen] = useState(false);
  // État pour filtrer les classes par enseignant sélectionné
  const [filterBySelectedTeacher, setFilterBySelectedTeacher] = useState(false);

  const [isProcessing, setIsProcessing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Pagination du bandeau "enseignants horaires à compléter"
  const [pendingPage, setPendingPage] = useState(1);
  const PENDING_PER_PAGE = 6;

  // Défilement automatique vers le panneau d'affectation après "Compléter"
  const [shouldScrollToAssignment, setShouldScrollToAssignment] = useState(false);
  const assignmentPanelRef = useRef(null);


  // Fonction unifiée
  const showToast = (message, type = 'success', options = {}) => {
    if (!message) return;
    setToastInfoState({ message, type, ...options });
  };

  // hideToast peut réutiliser la même logique de reset
  const hideToast = () => {
    setToastInfoState(null);
  };



  useEffect(() => {
    console.log('[DEBUG] availableSubjects mis ÃÂ  jour:', availableSubjects.length, 'matiÃÂ¨res');
    if (availableSubjects.length > 0) {
      console.log('[DEBUG] PremiÃÂ¨re matiÃÂ¨re disponible:', availableSubjects[0]);
      console.log('[DEBUG] Toutes les matiÃÂ¨res:', availableSubjects.map(m => m.nom));
    }
  }, [availableSubjects]);

  // Charger les donnÃÂ©es avec le nouveau systÃÂ¨me
  useEffect(() => {
    const loadData = async () => {
      try {


        // Charger l'annÃÂ©e scolaire active
        const yearResponse = await api.anneesScolaires.getActive();
        if (yearResponse.success && yearResponse.data) {
          setActiveYear(yearResponse.data);

          // Ã¢ÂÂ CHARGEMENT CORRIGÃÂ AVEC TOUTES LES MATIÃÂRES
          const [
            teachersRes,
            classesRes,
            assignmentsRes,
            statsRes,
            subjectsRes,
            sectionsRes,
            hourlyPendingRes
          ] = await Promise.all([
            api.employes.getEnseignantsAvecAffectationsDetaillees(yearResponse.data.id),
            api.classes.getAllByYear(yearResponse.data.id),
            api.affectations.getAll(yearResponse.data.id),
            api.affectations.getStatistiques(yearResponse.data.id),
            api.matieres.getAll(),
            api.sections.getAll(),
            api.affectations.getHorairesACompleter(yearResponse.data.id)
          ]);

          console.log('[DEBUG] RÃÂ©sultats du chargement:', {
            teachers: teachersRes,
            classes: classesRes,
            assignments: assignmentsRes,
            stats: statsRes,
            subjects: subjectsRes,
            horairesACompleter: hourlyPendingRes
          });

          if (teachersRes.success) {
            setTeachers(teachersRes.data);
            const rolesMap = {};
            teachersRes.data.forEach(teacher => {
              rolesMap[teacher.id] = teacher.role_id;
            });
            setTeacherRoles(rolesMap);
            console.log('[DEBUG] Teachers roles map:', rolesMap);
          }

          if (classesRes.success) {
            setClasses(classesRes.data);
            console.log('[DEBUG] Classes chargÃÂ©es:', classesRes.data.length);
          }

          if (assignmentsRes.success) {
            setAssignments(assignmentsRes.data);
            console.log('[DEBUG] Assignments chargÃÂ©es:', assignmentsRes.data.length);
          }

          if (statsRes.success) {
            setStatistics(statsRes.data);
            console.log('[DEBUG] Statistiques chargÃÂ©es:', statsRes.data);
          }

          if (sectionsRes?.success && Array.isArray(sectionsRes.data)) {
            setSections(sectionsRes.data);
          }

          if (hourlyPendingRes?.success) {
            setHourlyPendingAssignments(Array.isArray(hourlyPendingRes.data) ? hourlyPendingRes.data : []);
          }

          // Ã¢ÂÂ FORCER LE CHARGEMENT DES MATIÃÂRES IMMÃÂDIATEMENT
          if (subjectsRes.success && subjectsRes.data) {
            setAvailableSubjects(subjectsRes.data);
            //console.log('[DEBUG] MatiÃÂ¨res FORCÃÂES dans loadData:', subjectsRes.data.length, 'matiÃÂ¨res');
            //console.log('[DEBUG] PremiÃÂ¨re matiÃÂ¨re:', subjectsRes.data[0]);
          } else {
            //console.warn('[DEBUG] PROBLÃÂME avec le chargement des matiÃÂ¨res:', subjectsRes);
            setAvailableSubjects([]);
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des donnÃÂ©es:", error);
        showToast("Une erreur est survenue lors du chargement des donnÃÂ©es.", 'error');
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  // Obtenir le type d'enseignant (32 = principal, 33 = matiÃÂ¨re)
  const getTeacherType = (teacherId) => {
    const roleId = teacherRoles[teacherId];
    if (roleId === 32) return 'principal';
    if (roleId === 33) return 'matiere';
    return 'unknown';
  };

  // Filtrer les enseignants selon l'onglet actif
  const getFilteredTeachers = () => {
    let filtered = teachers.filter(teacher =>
      `${teacher.nom} ${teacher.prenom}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      teacher.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    switch (activeTab) {
      case 'principals':
        return filtered.filter(teacher => getTeacherType(teacher.id) === 'principal');
      case 'subjects':
        return filtered.filter(teacher => getTeacherType(teacher.id) === 'matiere');
      default:
        return filtered;
    }
  };

  // Obtenir les affectations selon le type d'enseignant
  const getTeacherAssignments = (teacherId) => {
    const teacherType = getTeacherType(teacherId);

    if (teacherType === 'principal') {
      // Pour les enseignants principaux : une seule classe
      return assignments.filter(a =>
        a.enseignant_id === teacherId && a.type === 'principal'
      );
    } else if (teacherType === 'matiere') {
      // Pour les enseignants de matiÃÂ¨re : plusieurs matiÃÂ¨res/classes
      return assignments.filter(a =>
        a.enseignant_id === teacherId && a.type === 'matiere'
      );
    }

    return [];
  };





  // Gérer les affectations intelligentes selon le type
  const handleSmartAssignment = async () => {
    if (selectedTeachers.length === 0 || !selectedSection || !selectedClass) {
      showToast("Veuillez sélectionner un enseignant, une section et une classe", 'error');
      return;
    }

    const teacher = teachers.find(t => t.id === selectedTeachers[0]);
    const teacherType = getTeacherType(teacher.id);
    const classObj = classes.find(c => c.id.toString() === selectedClass);

    if (teacherType === 'principal') {
      const classHasPrincipal = assignments.find(a =>
        a.classe_id.toString() === selectedClass && a.type === 'principal'
      );

      if (classHasPrincipal) {
        showToast(`Cette classe a déjà un enseignant principal`, 'error');
        return;
      }

      setConfirmDialog({
        isOpen: true,
        teacher: teacher,
        class: classObj,
        type: 'assign-principal',
        description: `Affecter ${teacher.prenom} ${teacher.nom} comme enseignant principal de la classe ${classObj.nom}. Cet enseignant aura toutes les matières de cette classe.`,
        subjects: [],
        assignmentId: null,
        subject: null
      });

    } else if (teacherType === 'matiere') {
      if (selectedSubjects.length === 0) {
        showToast("Veuillez sélectionner au moins une matière pour cet enseignant", 'error');
        return;
      }

      setConfirmDialog({
        isOpen: true,
        teacher: teacher,
        class: classObj,
        type: 'assign-subject',
        description: `Affecter ${teacher.prenom} ${teacher.nom} pour enseigner ${selectedSubjects.length} matière(s) dans la classe ${classObj.nom}.`,
        subjects: selectedSubjects,
        assignmentId: null,
        subject: null
      });
    }
  };



  // Confirmation améliorée// Confirmation améliorée
  const handleConfirmation = async () => {
    // ✅ Empêcher les doubles clics
    if (isProcessing) return;

    setIsProcessing(true); // ✅ Activer le loading

    const { teacher, class: classObj, type, subjects, assignmentId } = confirmDialog;

    try {
      let response;

      // GESTION DES AJOUTS
      if (type === 'assign-principal') {
        response = await api.affectations.enseignantsPrincipaux.create({
          enseignant_id: teacher.id,
          classe_id: classObj.id,
          annee_scolaire_id: activeYear.id
        });

        if (response.success) {
          showToast(`${teacher.prenom} ${teacher.nom} a été affecté(e) comme enseignant principal de la classe ${classObj.nom}.`);
        }
      }
      else if (type === 'assign-subject') {
        response = await api.affectations.enseignantsMatieres.createBatch({
          enseignant_id: teacher.id,
          annee_scolaire_id: activeYear.id,
          affectations: subjects.map(subjectId => ({
            matiere_id: subjectId,
            classe_id: classObj.id
          }))
        });

        if (response.success) {
          showToast(`${teacher.prenom} ${teacher.nom} a été affecté(e) pour ${subjects.length} matière(s) dans la classe ${classObj.nom}.`);
        }
      }

      // GESTION DES SUPPRESSIONS
      else if (type === 'remove-principal') {
        response = await api.affectations.enseignantsPrincipaux.delete(assignmentId);

        if (response.success) {
          showToast(`${teacher.prenom} ${teacher.nom} n'est plus enseignant principal de la classe ${classObj.nom}.`, 'success');
        } else {
          showToast(response.message || 'Erreur lors de la suppression de l\'enseignant principal.', 'error');
        }
      }

      else if (type === 'remove-subject') {
        response = await api.affectations.enseignantsMatieres.delete(assignmentId);

        if (response.success) {
          showToast(`${teacher.prenom} ${teacher.nom} n'enseigne plus ${confirmDialog.subject?.nom} dans la classe ${classObj.nom}.`, 'success');
        } else {
          showToast(response.message || 'Erreur lors de la suppression de l\'affectation.', 'error');
        }
      }

      // RECHARGER LES DONNÉES SI SUCCÈS
      if (response && response.success) {
        const [assignmentsRes, statsRes, teachersRes, hourlyPendingRes] = await Promise.all([
          api.affectations.getAll(activeYear.id),
          api.affectations.getStatistiques(activeYear.id),
          api.employes.getEnseignantsAvecAffectationsDetaillees(activeYear.id),
          api.affectations.getHorairesACompleter(activeYear.id)
        ]);

        if (assignmentsRes.success) setAssignments(assignmentsRes.data);
        if (statsRes.success) setStatistics(statsRes.data);
        if (teachersRes.success) setTeachers(teachersRes.data);
        if (hourlyPendingRes?.success) setHourlyPendingAssignments(Array.isArray(hourlyPendingRes.data) ? hourlyPendingRes.data : []);

        // Réinitialiser les sélections pour les ajouts
        if (type.startsWith('assign-')) {
          setSelectedTeachers([]);
          setSelectedClass('');
          setSelectedSubjects([]);
        }
      } else if (response) {
        showToast(response.message || 'Une erreur est survenue lors de l\'opération.', 'error');
      }

    } catch (error) {
      console.error("Erreur lors de l'opération:", error);
      showToast("Une erreur est survenue lors de l'opération.", 'error');
    } finally {
      setIsProcessing(false); // ✅ Désactiver le loading
      setConfirmDialog({
        isOpen: false,
        teacher: null,
        class: null,
        type: '',
        description: '',
        subjects: [],
        assignmentId: null,
        subject: null
      });
    }
  };




  // Charger les matiÃÂ¨res disponibles pour une classe
  const loadSubjectsForClass = async (classId) => {
    console.log('[DEBUG] loadSubjectsForClass appelÃÂ©e avec:', classId, 'activeYear:', activeYear);

    if (!activeYear) {
      console.log('[DEBUG] Pas d\'annÃÂ©e active, rechargement de toutes les matiÃÂ¨res');
      const allSubjectsResponse = await api.matieres.getAll();
      if (allSubjectsResponse.success && allSubjectsResponse.data) {
        setAvailableSubjects(allSubjectsResponse.data);
        console.log('[DEBUG] Toutes les matiÃÂ¨res chargÃÂ©es (pas d\'annÃÂ©e):', allSubjectsResponse.data.length);
      }
      return;
    }

    if (!classId) {
      console.log('[DEBUG] Pas de classe sÃÂ©lectionnÃÂ©e, conservation des matiÃÂ¨res existantes');
      return;
    }

    try {
      console.log('[DEBUG] Tentative de chargement des matiÃÂ¨res pour classe:', classId);

      // Toujours essayer de rÃÂ©cupÃÂ©rer toutes les matiÃÂ¨res d'abord
      const allSubjectsResponse = await api.matieres.getAll();

      if (allSubjectsResponse.success && allSubjectsResponse.data && allSubjectsResponse.data.length > 0) {
        setAvailableSubjects(allSubjectsResponse.data);
        console.log('[DEBUG] Toutes les matiÃÂ¨res chargÃÂ©es pour sÃÂ©lection:', allSubjectsResponse.data.length);
        return;
      }

      // Si ÃÂ©chec, essayer les matiÃÂ¨res spÃÂ©cifiques ÃÂ  la classe
      console.log('[DEBUG] Tentative des matiÃÂ¨res spÃÂ©cifiques ÃÂ  la classe');
      const response = await api.matieres.getDisponibles(classId, activeYear.id);

      if (response.success && response.data && response.data.length > 0) {
        setAvailableSubjects(response.data);
        console.log('[DEBUG] MatiÃÂ¨res spÃÂ©cifiques ÃÂ  la classe chargÃÂ©es:', response.data.length);
      } else {
        console.log('[DEBUG] Aucune matiÃÂ¨re spÃÂ©cifique trouvÃÂ©e, conservation des matiÃÂ¨res existantes');
      }
    } catch (error) {
      console.error("Erreur lors du chargement des matiÃÂ¨res:", error);
      console.log('[DEBUG] Erreur, conservation des matiÃÂ¨res existantes');
    }
  };



  const getSectionIcon = (sectionName) => {
    const name = sectionName.toLowerCase();
    if (name.includes('préscolaire') || name.includes('prescolaire') || name.includes('maternelle')) {
      return <Baby className="w-4 h-4 text-[#246990]" />;
    }
    if (name.includes('primaire') || name.includes('élémentaire')) {
      return <BookOpenIcon className="w-4 h-4 text-[#246990]" />;
    }
    if (name.includes('collège') || name.includes('college')) {
      return <School className="w-4 h-4 text-[#246990]" />;
    }
    if (name.includes('lycée') || name.includes('lycee') || name.includes('secondaire')) {
      return <Building className="w-4 h-4 text-[#246990]" />;
    }
    return <GraduationCap className="w-4 h-4 text-[#246990]" />;
  };

  const toggleExpansion = (sectionId) => {
    setExpandedSections(prev => {
      const newSet = new Set(prev);
      if (newSet.has(sectionId)) {
        newSet.delete(sectionId);
      } else {
        newSet.add(sectionId);
      }
      return newSet;
    });
  };

  // Effet pour charger les matiÃÂ¨res quand une classe est sÃÂ©lectionnÃÂ©e
  useEffect(() => {
    console.log('[DEBUG] Effect pour classe sÃÂ©lectionnÃÂ©e:', selectedClass);
    if (selectedClass) {
      loadSubjectsForClass(selectedClass);
    } else {
      // MÃÂªme si pas de classe sÃÂ©lectionnÃÂ©e, charger toutes les matiÃÂ¨res
      loadSubjectsForClass(null);
    }
  }, [selectedClass, activeYear]);



  // Effet pour charger les matières quand une classe est sélectionnée
  useEffect(() => {
    console.log('[DEBUG] Effect pour classe sélectionnée:', selectedClass);
    if (selectedClass) {
      loadSubjectsForClass(selectedClass);
    } else {
      // Même si pas de classe sélectionnée, charger toutes les matières
      loadSubjectsForClass(null);
    }
  }, [selectedClass, activeYear]);

  // ✅ AJOUTER CE NOUVEAU useEffect ICI
  // Fermer les dropdowns en cliquant à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Vérifier si le clic est en dehors des dropdowns
      const clickedElement = event.target;
      const isInsideDropdown = clickedElement.closest('.relative');

      if (!isInsideDropdown) {
        if (isSectionDropdownOpen) {
          setIsSectionDropdownOpen(false);
        }
        if (isClassDropdownOpen) {
          setIsClassDropdownOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSectionDropdownOpen, isClassDropdownOpen]);




  const toggleTeacherSelection = (teacherId) => {
    setSelectedTeachers(prev => {
      const isCurrentlySelected = prev.includes(teacherId);

      if (isCurrentlySelected) {
        // Désélection : désactiver le filtre
        setFilterBySelectedTeacher(false);
        return [];
      } else {
        // Sélection : activer le filtre automatiquement
        setFilterBySelectedTeacher(true);
        return [teacherId];
      }
    });
  };

  const clearSelection = () => {
    setSelectedTeachers([]);
    setSelectedClass('');
    setSelectedSection('');
    setSelectedSubjects([]);
    setFilterBySelectedTeacher(false);
    // ✅ AJOUTER CES LIGNES
    setSectionSearchTerm('');
    setIsSectionDropdownOpen(false);
    setClassSearchTerm('');
    setIsClassDropdownOpen(false);
  };

  // Fonction pour filtrer les sections et classes selon l'enseignant sélectionné
  const getFilteredSectionsAndClasses = () => {
    if (!filterBySelectedTeacher || selectedTeachers.length === 0) {
      // Pas de filtre : retourner toutes les sections et classes
      return { filteredSections: sections, filteredClasses: classes };
    }

    const selectedTeacherId = selectedTeachers[0];

    // Récupérer toutes les affectations de l'enseignant sélectionné
    const teacherAssignments = assignments.filter(a => a.enseignant_id === selectedTeacherId);

    // Récupérer les IDs des classes où l'enseignant est affecté
    const assignedClassIds = [...new Set(teacherAssignments.map(a => a.classe_id))];

    // Filtrer les classes
    const filteredClasses = classes.filter(c =>
      assignedClassIds.includes(c.id) || assignedClassIds.includes(c.id.toString())
    );

    // Filtrer les sections qui ont au moins une classe affectée
    const assignedSectionIds = [...new Set(filteredClasses.map(c => c.section_id))];
    const filteredSections = sections.filter(s =>
      assignedSectionIds.includes(s.id) || assignedSectionIds.includes(s.id.toString())
    );

    return { filteredSections, filteredClasses };
  };


  // Fonction pour calculer les statistiques de l'enseignant sélectionné
  const getSelectedTeacherStats = () => {
    if (!filterBySelectedTeacher || selectedTeachers.length === 0) {
      return null;
    }

    const selectedTeacherId = selectedTeachers[0];
    const teacher = teachers.find(t => t.id === selectedTeacherId);
    const teacherType = getTeacherType(selectedTeacherId);

    // Récupérer toutes les affectations de l'enseignant
    const teacherAssignments = assignments.filter(a => a.enseignant_id === selectedTeacherId);

    // Compter les classes uniques
    const uniqueClassIds = [...new Set(teacherAssignments.map(a => a.classe_id))];
    const classCount = uniqueClassIds.length;

    // Compter les affectations par type
    const principalCount = teacherAssignments.filter(a => a.type === 'principal').length;
    const subjectCount = teacherAssignments.filter(a => a.type === 'matiere').length;

    // Compter les matières uniques (pour enseignants de matière)
    const uniqueSubjectIds = [...new Set(
      teacherAssignments
        .filter(a => a.type === 'matiere' && a.matiere_id)
        .map(a => a.matiere_id)
    )];
    const uniqueSubjectsCount = uniqueSubjectIds.length;

    return {
      teacher,
      teacherType,
      classCount,
      principalCount,
      subjectCount,
      uniqueSubjectsCount,
      totalAssignments: teacherAssignments.length
    };
  };


  // Fonction pour vérifier si un enseignant est celui sélectionné
  const isSelectedTeacher = (teacherId) => {
    return filterBySelectedTeacher &&
      selectedTeachers.length > 0 &&
      selectedTeachers[0] === teacherId;
  };

  const handleUseHourlyPending = (pending) => {
    const teacherId = Number(pending.enseignant_id);
    const classId = pending.classe_id?.toString() || '';
    const sectionId = pending.section_id?.toString() || '';

    setActiveTab('subjects');
    setSelectedTeachers([teacherId]);
    setSelectedSection(sectionId);
    setSelectedClass(classId);
    setSelectedSubjects([]);
    setFilterBySelectedTeacher(true);
    setTeacherPage(1);
    setSectionSearchTerm('');
    setClassSearchTerm('');
    setIsSectionDropdownOpen(false);
    setIsClassDropdownOpen(false);

    if (pending.section_id) {
      setExpandedSections(prev => {
        const next = new Set(prev);
        next.add(pending.section_id);
        return next;
      });
    }

    setShouldScrollToAssignment(true);
    showToast(`${pending.enseignant_prenom} ${pending.enseignant_nom} est prêt pour ${pending.classe_nom}. Choisissez la matière à affecter.`, 'success');
  };

  // Défiler vers le panneau d'affectation une fois la présélection appliquée et affichée
  useEffect(() => {
    if (shouldScrollToAssignment && selectedTeachers.length > 0 && assignmentPanelRef.current) {
      assignmentPanelRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setShouldScrollToAssignment(false);
    }
  }, [shouldScrollToAssignment, selectedTeachers, selectedClass]);

  // Rendu du composant
  return (
    <div className="bg-white border-0 rounded-xl p-6 shadow-sm">
      <div className="mb-6">

        {/* Statistiques amÃÂ©liorÃÂ©es */}
        {statistics && (
          <div className="grid grid-cols-2 gap-3 max-w-md">
            <Card className="border-0 shadow-md overflow-hidden">
              <div className="bg-gradient-to-r from-[#319190] to-[#63b5b4] text-white p-3">
                <CardTitle className="text-xs font-medium flex items-center gap-1.5 mb-1">
                  <UserCheck size={14} className="text-white" />
                  <span className="leading-tight">Enseignants principaux</span>
                </CardTitle>
                <span className="text-xl font-bold">{statistics.enseignants_principaux || 0}</span>
              </div>
            </Card>
            <Card className="border-0 shadow-md overflow-hidden">
              <div className="bg-gradient-to-r from-[#246990] to-[#3084b5] text-white p-3">
                <CardTitle className="text-xs font-medium flex items-center gap-1.5 mb-1">
                  <GraduationCap size={14} className="text-white" />
                  <span className="leading-tight">Enseignants de matière</span>
                </CardTitle>
                <span className="text-xl font-bold">{statistics.enseignants_matieres || 0}</span>
              </div>
            </Card>
          </div>
        )}
      </div>


      {/* Toast */}
      {toastInfo && (
        shouldUseLongToast(toastInfo.message, toastInfo.type, toastInfo) ? (
          <LongToast
            show
            title={toastInfo.title}
            message={toastInfo.message}
            type={toastInfo.type}
            onClose={hideToast}
          />
        ) : (
          <Toast
            message={toastInfo.message}
            type={toastInfo.type}
            onClose={hideToast}
          />
        )
      )}

      {hourlyPendingAssignments.length > 0 && (
        <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 p-4">
          <div className="flex items-start justify-between gap-4">
            <div className="flex items-start gap-3">
              <div className="mt-0.5 rounded-lg bg-amber-100 p-2 text-amber-700">
                <Clock size={18} />
              </div>
              <div>
                <h4 className="font-semibold text-amber-900">
                  {hourlyPendingAssignments.length} enseignant{hourlyPendingAssignments.length > 1 ? 's' : ''} horaire{hourlyPendingAssignments.length > 1 ? 's' : ''} à compléter
                </h4>
                <p className="mt-1 text-sm text-amber-800">
                  Ces enseignants sont déjà liés à une classe dans Nouvel employé. Il reste à choisir la matière pour créer l'affectation emploi du temps.
                </p>
              </div>
            </div>
            <AlertCircle className="mt-1 h-5 w-5 flex-shrink-0 text-amber-700" />
          </div>

          {(() => {
            const totalPendingPages = Math.ceil(hourlyPendingAssignments.length / PENDING_PER_PAGE);
            const safePendingPage = Math.min(pendingPage, totalPendingPages) || 1;
            const startIndex = (safePendingPage - 1) * PENDING_PER_PAGE;
            const paginatedPending = hourlyPendingAssignments.slice(startIndex, startIndex + PENDING_PER_PAGE);

            return (
              <>
                <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                  {paginatedPending.map((pending) => (
                    <div key={`${pending.enseignant_id}-${pending.classe_id}`} className="rounded-lg border border-amber-200 bg-white p-3">
                      <div className="flex items-start justify-between gap-3">
                        <div className="min-w-0">
                          <p className="truncate text-sm font-semibold text-gray-900">
                            {pending.enseignant_prenom} {pending.enseignant_nom}
                          </p>
                          <p className="mt-1 text-xs text-gray-600">
                            {pending.classe_nom}{pending.section_nom ? ` · ${pending.section_nom}` : ''}
                          </p>
                          <p className="mt-1 text-xs text-amber-700">
                            {Number(pending.heures_semaine || 0)} h/sem · {Number(pending.matieres_disponibles || 0)} matière{Number(pending.matieres_disponibles || 0) > 1 ? 's' : ''} disponible{Number(pending.matieres_disponibles || 0) > 1 ? 's' : ''}
                          </p>
                        </div>
                        <Button
                          type="button"
                          size="sm"
                          onClick={() => handleUseHourlyPending(pending)}
                          className="gap-1 bg-[#246990] text-white hover:bg-[#3084b5]"
                        >
                          <Plus size={13} />
                          Compléter
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>

                {totalPendingPages > 1 && (
                  <div className="mt-4 flex items-center justify-between border-t border-amber-200 pt-3">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => setPendingPage(prev => Math.max(1, prev - 1))}
                      disabled={safePendingPage === 1}
                      className="border-amber-300"
                    >
                      Précédent
                    </Button>
                    <span className="text-xs text-amber-800">
                      {safePendingPage} / {totalPendingPages} · {hourlyPendingAssignments.length} au total
                    </span>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => setPendingPage(prev => Math.min(totalPendingPages, prev + 1))}
                      disabled={safePendingPage === totalPendingPages}
                      className="border-amber-300"
                    >
                      Suivant
                    </Button>
                  </div>
                )}
              </>
            );
          })()}
        </div>
      )}


      {isLoading ? (
        <div className="flex items-center justify-center h-64">
          <LoadingSpinner message="Chargement des affectations..." color="#246990" />
        </div>
      ) : (
        <>
          {/* Onglets pour filtrer par type d'enseignant */}
          <div className="flex space-x-1 mb-6 bg-gray-100 p-1 rounded-lg">
            <button
              onClick={() => setActiveTab('all')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'all'
                  ? 'bg-[#246990] text-white shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
                }`}
            >
              <Users size={16} className="inline mr-2" />
              Tous les enseignants
            </button>
            <button
              onClick={() => setActiveTab('principals')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'principals'
                  ? 'bg-green-600 text-white shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
                }`}
            >
              <UserCheck size={16} className="inline mr-2" />
              Enseignants principaux
            </button>
            <button
              onClick={() => setActiveTab('subjects')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'subjects'
                  ? 'bg-blue-600 text-white shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
                }`}
            >
              <GraduationCap size={16} className="inline mr-2" />
              Enseignants de matière
            </button>
          </div>


          <div className="flex flex-col lg:flex-row gap-6">
            {/* Liste des enseignants (colonne de gauche) */}
            <div className="w-full lg:w-1/3">
              <div className="bg-gray-50 rounded-xl p-4">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <Users size={20} className="text-[#246990] mr-2" />
                    <h4 className="font-semibold text-gray-700">
                      {activeTab === 'principals' ? 'Enseignants principaux' :
                        activeTab === 'subjects' ? 'Enseignants de matière' :
                          'Tous les enseignants'}
                    </h4>
                    <span className="ml-2 bg-[#246990] text-white text-xs px-2 py-1 rounded-full">
                      {getFilteredTeachers().length}
                    </span>
                  </div>
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={clearSelection}
                    className="bg-gray-100 text-gray-700 hover:bg-gray-200"
                  >
                    Déselectionner
                  </Button>
                </div>

                <div className="relative mb-4">
                  <input
                    type="text"
                    placeholder="Rechercher un enseignant..."
                    className="w-full px-4 py-2 pl-10 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#246990]"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <Search size={16} className="absolute left-3 top-3 text-gray-400" />
                </div>


                <div className="min-h-[400px] bg-white rounded-lg border border-gray-200 p-2 overflow-y-auto mb-4">
                  {(() => {
                    const filteredTeachers = getFilteredTeachers();
                    const totalTeacherPages = Math.ceil(filteredTeachers.length / teachersPerPage);
                    const startIndex = (teacherPage - 1) * teachersPerPage;
                    const paginatedTeachers = filteredTeachers.slice(startIndex, startIndex + teachersPerPage);

                    return (
                      <>
                        {paginatedTeachers.length === 0 ? (
                          <div className="flex flex-col items-center justify-center h-40 text-center text-gray-500">
                            <Users size={40} className="mb-2 text-gray-300" />
                            <p>Aucun enseignant trouvé</p>
                          </div>
                        ) : (
                          <>
                            {/* Liste des enseignants */}
                            <div className="space-y-2 mb-4">
                              {paginatedTeachers.map((teacher) => {
                                const teacherType = getTeacherType(teacher.id);
                                const assignmentCount = getTeacherAssignments(teacher.id).length;

                                return (
                                  <div
                                    key={teacher.id}
                                    className={`p-3 rounded-lg transition-all duration-200 cursor-pointer ${selectedTeachers.includes(teacher.id)
                                        ? 'bg-[#246990] text-white'
                                        : 'bg-gray-50 hover:bg-gray-100 hover:shadow-sm'
                                      }`}
                                    onClick={() => toggleTeacherSelection(teacher.id)}
                                  >
                                    <div className="flex items-center">
                                      <input
                                        type="radio"
                                        name="selectedTeacher"
                                        checked={selectedTeachers.includes(teacher.id)}
                                        onChange={() => toggleTeacherSelection(teacher.id)}
                                        className="mr-3 text-[#246990] focus:ring-[#246990]"
                                      />


                                      <div className="flex-1">
                                        <div className={`font-medium ${selectedTeachers.includes(teacher.id) ? 'text-white' : 'text-gray-800'}`}>
                                          {teacher.nom} {teacher.prenom}
                                        </div>
                                      </div>

                                      {assignmentCount > 0 && (
                                        <div className={`px-2 py-1 rounded-full text-xs font-medium ${selectedTeachers.includes(teacher.id)
                                            ? 'bg-white/20 text-white'
                                            : teacherType === 'principal' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'
                                          }`}>
                                          {assignmentCount} {teacherType === 'principal' ? 'classe' : 'affectation(s)'}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>

                            {/* Pagination */}
                            {totalTeacherPages > 1 && (
                              <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                                <Button
                                  size="sm"
                                  variant="outline"
                                  onClick={() => setTeacherPage(prev => Math.max(1, prev - 1))}
                                  disabled={teacherPage === 1}
                                  className="border-gray-300"
                                >
                                  Précédent
                                </Button>
                                <span className="text-xs text-gray-600">
                                  {teacherPage} / {totalTeacherPages}
                                </span>
                                <Button
                                  size="sm"
                                  variant="outline"
                                  onClick={() => setTeacherPage(prev => Math.min(totalTeacherPages, prev + 1))}
                                  disabled={teacherPage === totalTeacherPages}
                                  className="border-gray-300"
                                >
                                  Suivant
                                </Button>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    );
                  })()}
                </div>



                {/* Panel d'affectation intelligent */}
                {selectedTeachers.length > 0 && (
                  <div ref={assignmentPanelRef} className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                    <h5 className="font-medium text-blue-900 mb-3">
                      Affectatation
                    </h5>

                    <div className="space-y-3">



                      {/* Sélection hiérarchique Section -> Classe */}

                      {/* Sélection hiérarchique Section -> Classe */}
                      <div className="space-y-3">
                        {/* ✅ SECTION - Dropdown vers le haut */}
                        <div>
                          <label className="block text-sm font-medium text-blue-900 mb-1">
                            Section
                          </label>

                          <div className="relative">
                            <Search className="absolute left-2.5 top-2 h-3.5 w-3.5 text-gray-400 pointer-events-none" />

                            <input
                              type="text"
                              placeholder="Rechercher une section..."
                              value={(() => {
                                if (selectedSection) {
                                  const section = sections.find(s => s.id.toString() === selectedSection);
                                  return section ? section.nom : '';
                                }
                                return sectionSearchTerm;
                              })()}
                              onChange={(e) => {
                                setSectionSearchTerm(e.target.value);
                                setIsSectionDropdownOpen(true);
                                if (selectedSection) {
                                  setSelectedSection('');
                                  setSelectedClass('');
                                  setClassSearchTerm('');
                                }
                              }}
                              onFocus={() => setIsSectionDropdownOpen(true)}
                              className="w-full pl-8 pr-3 py-1.5 text-sm border border-blue-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#246990]"
                            />

                            {/* ✅ Dropdown vers le HAUT */}
                            {isSectionDropdownOpen && !selectedSection && (
                              <div className="absolute z-20 w-full top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                {(() => {
                                  const filteredSections = sections
                                    .filter(section =>
                                      section.nom.toLowerCase().includes(sectionSearchTerm.toLowerCase())
                                    )
                                    .sort((a, b) => {
                                      if (a.ordre && b.ordre) return a.ordre - b.ordre;
                                      if (a.ordre) return -1;
                                      if (b.ordre) return 1;
                                      return a.nom.localeCompare(b.nom);
                                    });

                                  if (filteredSections.length === 0) {
                                    return (
                                      <div className="p-2 text-center text-gray-500 text-xs">
                                        Aucune section trouvée
                                      </div>
                                    );
                                  }

                                  return filteredSections.map((section) => (
                                    <div
                                      key={section.id}
                                      onClick={() => {
                                        setSelectedSection(section.id.toString());
                                        setSectionSearchTerm('');
                                        setIsSectionDropdownOpen(false);
                                        setSelectedClass('');
                                        setClassSearchTerm('');
                                      }}
                                      className="px-3 py-2 hover:bg-gray-50 cursor-pointer border-b last:border-b-0 transition-colors"
                                    >
                                      <div className="flex items-center gap-2">
                                        <div className="flex-shrink-0">
                                          {getSectionIcon(section.nom)}
                                        </div>
                                        <div className="flex-1 min-w-0">
                                          <div className="font-medium text-gray-900 text-sm truncate">
                                            {section.nom}
                                          </div>
                                          <div className="text-xs text-gray-500">
                                            {classes.filter(c => c.section_id === section.id).length} classe{classes.filter(c => c.section_id === section.id).length > 1 ? 's' : ''}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ));
                                })()}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ✅ CLASSE - Dropdown vers le haut */}
                        {selectedSection && (
                          <div>
                            <label className="block text-sm font-medium text-blue-900 mb-1">
                              Classe
                            </label>

                            <div className="relative">
                              <Search className="absolute left-2.5 top-2 h-3.5 w-3.5 text-gray-400 pointer-events-none" />

                              <input
                                type="text"
                                placeholder="Rechercher une classe..."
                                value={(() => {
                                  if (selectedClass) {
                                    const classe = classes.find(c => c.id.toString() === selectedClass);
                                    return classe ? classe.nom : '';
                                  }
                                  return classSearchTerm;
                                })()}
                                onChange={(e) => {
                                  setClassSearchTerm(e.target.value);
                                  setIsClassDropdownOpen(true);
                                  if (selectedClass) {
                                    setSelectedClass('');
                                  }
                                }}
                                onFocus={() => setIsClassDropdownOpen(true)}
                                className="w-full pl-8 pr-3 py-1.5 text-sm border border-blue-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#246990]"
                              />

                              {/* ✅ Dropdown vers le HAUT */}
                              {isClassDropdownOpen && !selectedClass && (
                                <div className="absolute z-10 w-full top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                  {(() => {
                                    const filteredClasses = classes
                                      .filter(classe => classe.section_id.toString() === selectedSection)
                                      .filter(classe =>
                                        classe.nom.toLowerCase().includes(classSearchTerm.toLowerCase())
                                      )
                                      .sort((a, b) => {
                                        if (a.ordre && b.ordre) return a.ordre - b.ordre;
                                        return a.nom.localeCompare(b.nom);
                                      });

                                    if (filteredClasses.length === 0) {
                                      return (
                                        <div className="p-2 text-center text-gray-500 text-xs">
                                          Aucune classe trouvée
                                        </div>
                                      );
                                    }

                                    return filteredClasses.map((classe) => (
                                      <div
                                        key={classe.id}
                                        onClick={() => {
                                          setSelectedClass(classe.id.toString());
                                          setClassSearchTerm('');
                                          setIsClassDropdownOpen(false);
                                        }}
                                        className="px-3 py-2 hover:bg-gray-50 cursor-pointer border-b last:border-b-0 transition-colors"
                                      >
                                        <div className="font-medium text-gray-900 text-sm">
                                          {classe.nom}
                                        </div>

                                      </div>
                                    ));
                                  })()}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      {/* SÃÂ©lection de matiÃÂ¨res (pour enseignants de matiÃÂ¨re uniquement) */}
                      {selectedClass && selectedTeachers.length > 0 &&
                        getTeacherType(selectedTeachers[0]) === 'matiere' && (
                          <div>
                            <label className="block text-sm font-medium text-blue-900 mb-2">
                              Matières à enseigner ({availableSubjects.length} disponibles) :
                            </label>

                            {/* Ã¢ÂÂ DEBUG TEMPORAIRE */}

                            {/*<div className="text-xs text-gray-500 mb-2">
                              DEBUG: {availableSubjects.length} matiÃÂ¨res chargÃÂ©es
                              {availableSubjects.length > 0 && ` - PremiÃÂ¨re: ${availableSubjects[0].nom}`}
                            </div>*/}

                            <div className="max-h-32 overflow-y-auto border border-blue-300 rounded-lg p-2 bg-white">
                              {availableSubjects.length === 0 ? (
                                <div className="text-sm text-gray-500 p-2">
                                  Aucune matière disponible.
                                </div>
                              ) : (
                                availableSubjects.map((subject) => (
                                  <label key={subject.id} className="flex items-center space-x-2 p-1 hover:bg-gray-50 rounded">
                                    <input
                                      type="checkbox"
                                      checked={selectedSubjects.includes(subject.id)}
                                      onChange={(e) => {
                                        console.log('[DEBUG] MatiÃÂ¨re sÃÂ©lectionnÃÂ©e/dÃÂ©sÃÂ©lectionnÃÂ©e:', subject.nom, e.target.checked);
                                        if (e.target.checked) {
                                          setSelectedSubjects([...selectedSubjects, subject.id]);
                                        } else {
                                          setSelectedSubjects(selectedSubjects.filter(id => id !== subject.id));
                                        }
                                      }}
                                      className="text-blue-600 focus:ring-blue-500"
                                    />
                                    <span className="text-sm">{subject.nom}</span>
                                  </label>
                                ))
                              )}
                            </div>

                            {selectedSubjects.length > 0 && (
                              <div className="text-xs text-blue-700 mt-1">
                                {selectedSubjects.length} matière(s) sélectionnée(s)
                              </div>
                            )}
                          </div>
                        )}

                      <Button
                        size="default"
                        onClick={handleSmartAssignment}
                        disabled={!selectedSection || !selectedClass ||
                          (getTeacherType(selectedTeachers[0]) === 'matiere' && selectedSubjects.length === 0)}
                        className="w-full bg-[#246990] text-white hover:bg-[#3084b5] disabled:bg-gray-400 disabled:cursor-not-allowed"
                      >
                        <Plus className="h-4 w-4 mr-2" />
                        Affecter
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Liste des classes avec affichage intelligent par sections */}


            <div className="w-full lg:w-2/3">
              <div className="bg-gray-50 rounded-xl p-4">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <BookOpen size={20} className="text-[#246990] mr-2" />
                    <h4 className="font-semibold text-gray-700">Classes et affectations par section</h4>
                  </div>

                  {/* Indicateur de filtre actif + Statistiques */}
                  {filterBySelectedTeacher && selectedTeachers.length > 0 && (() => {
                    const stats = getSelectedTeacherStats();

                    return (
                      <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                          <div className="flex items-center gap-2 bg-blue-100 text-blue-700 px-3 py-1 rounded-lg text-sm">
                            <User size={14} />
                            <span>
                              Filtré par : {stats?.teacher ? `${stats.teacher.prenom} ${stats.teacher.nom}` : ''}
                            </span>
                          </div>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => {
                              setFilterBySelectedTeacher(false);
                              setSelectedTeachers([]);
                            }}
                            className="bg-gray-200 text-gray-700 hover:bg-gray-300"
                          >
                            Réinitialiser
                          </Button>
                        </div>

                        {/* ✅ STATISTIQUES CONTEXTUELLES */}
                        {stats && (
                          <div className="flex items-center gap-3 text-xs bg-white border border-blue-200 rounded-lg px-3 py-2">
                            {/* Nombre de classes */}
                            <div className="flex items-center gap-1">
                              <BookOpen size={12} className="text-[#246990]" />
                              <span className="font-medium text-gray-700">
                                {stats.classCount} classe{stats.classCount > 1 ? 's' : ''}
                              </span>
                            </div>

                            {/* Séparateur */}
                            <div className="h-3 w-px bg-gray-300"></div>

                            {/* Stats selon le type d'enseignant */}
                            {stats.teacherType === 'principal' ? (
                              <div className="flex items-center gap-1">
                                <UserCheck size={12} className="text-green-600" />
                                <span className="text-gray-600">
                                  Enseignant principal
                                </span>
                              </div>
                            ) : (
                              <>
                                <div className="flex items-center gap-1">
                                  <GraduationCap size={12} className="text-blue-600" />
                                  <span className="text-gray-600">
                                    {stats.uniqueSubjectsCount} matière{stats.uniqueSubjectsCount > 1 ? 's' : ''}
                                  </span>
                                </div>

                                <div className="h-3 w-px bg-gray-300"></div>

                                <div className="flex items-center gap-1">
                                  <span className="text-gray-600">
                                    {stats.subjectCount} affectation{stats.subjectCount > 1 ? 's' : ''}
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })()}

                </div>



                <div className="space-y-4">
                  {(() => {

                    // ✅ AJOUTÉ : Récupérer les sections et classes filtrées
                    const { filteredSections, filteredClasses } = getFilteredSectionsAndClasses();
                    // Grouper les classes par section
                    const classesBySection = classes.reduce((acc, classe) => {
                      const sectionId = classe.section_id;
                      if (!acc[sectionId]) {
                        acc[sectionId] = [];
                      }
                      acc[sectionId].push(classe);
                      return acc;
                    }, {});

                    // Trier les sections par ordre
                    const sortedSections = filteredSections.sort((a, b) => {
                      if (a.ordre && b.ordre) return a.ordre - b.ordre;
                      if (a.ordre) return -1;
                      if (b.ordre) return 1;
                      return a.nom.localeCompare(b.nom);
                    });

                    return sortedSections.map(section => {
                      const sectionClasses = classesBySection[section.id] || [];
                      const isExpanded = expandedSections.has(section.id);

                      if (sectionClasses.length === 0) return null;

                      // Calculer les stats de la section
                      const classesWithPrincipal = sectionClasses.filter(classe =>
                        assignments.some(a =>
                          a.classe_id.toString() === classe.id.toString() && a.type === 'principal'
                        )
                      ).length;

                      return (
                        <div key={section.id} className="border border-gray-200 rounded-lg overflow-hidden bg-white">
                          {/* En-tÃÂªte de section */}
                          <div
                            className="flex items-center justify-between p-4 hover:bg-gray-50 cursor-pointer transition-colors bg-gray-25 border-b border-gray-100"
                            onClick={() => toggleExpansion(section.id)}
                          >
                            <div className="flex items-center space-x-3">
                              {/* IcÃÂ´ne d'expansion */}
                              <div className="text-gray-400">
                                {isExpanded ? (
                                  <ChevronDown className="w-5 h-5" />
                                ) : (
                                  <ChevronRight className="w-5 h-5" />
                                )}
                              </div>

                              {/* IcÃÂ´ne de section */}
                              <div className="text-[#246990]">
                                {getSectionIcon(section.nom)}
                              </div>

                              {/* Nom de section et stats */}
                              <div>
                                <h4 className="font-semibold text-gray-900">{section.nom}</h4>
                                <p className="text-sm text-gray-500">
                                  {sectionClasses.length} classe{sectionClasses.length > 1 ? 's' : ''} •
                                  {classesWithPrincipal} avec enseignant principal
                                </p>
                              </div>
                            </div>

                            {/* Badge de progression */}
                            {/* <div className="flex items-center space-x-2">
                        <div className={`px-3 py-1 rounded-full text-xs font-medium ${
                          classesWithPrincipal === sectionClasses.length 
                            ? 'bg-green-100 text-green-800' 
                            : classesWithPrincipal > 0
                            ? 'bg-yellow-100 text-yellow-800'
                            : 'bg-red-100 text-red-800'
                        }`}>
                          {classesWithPrincipal}/{sectionClasses.length}
                        </div>
                      </div>*/}

                          </div>

                          {/* Classes de la section */}
                          {isExpanded && (
                            <div className="p-4">
                              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                {sectionClasses
                                  .sort((a, b) => {
                                    if (a.ordre && b.ordre) return a.ordre - b.ordre;
                                    return a.nom.localeCompare(b.nom);
                                  })
                                  .map((classItem) => {
                                    const principalAssignments = assignments.filter(a =>
                                      a.classe_id.toString() === classItem.id.toString() && a.type === 'principal'
                                    );
                                    const subjectAssignments = assignments.filter(a =>
                                      a.classe_id.toString() === classItem.id.toString() && a.type === 'matiere'
                                    );

                                    const hasPrincipal = principalAssignments.length > 0;
                                    const subjectCount = subjectAssignments.length;

                                    return (
                                      <div key={classItem.id} className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
                                        <div className={`p-3 border-b border-gray-200 ${hasPrincipal ? 'bg-green-50' : 'bg-yellow-50'
                                          }`}>
                                          <div className="flex items-center justify-between">
                                            <h5 className={`font-medium ${hasPrincipal ? 'text-green-700' : 'text-yellow-700'
                                              }`}>
                                              {classItem.nom}
                                              {hasPrincipal && <UserCheck size={16} className="inline ml-2" />}
                                            </h5>
                                          </div>
                                          <div className="text-sm text-gray-500 flex items-center justify-between">


                                          </div>
                                        </div>

                                        <div className="p-3 space-y-3">
                                          {/* Enseignant principal */}
                                          <div>
                                            <div className="text-xs font-medium text-gray-500 mb-2 flex items-center">
                                              <UserCheck size={12} className="mr-1" />
                                              Enseignant principal
                                            </div>
                                            {principalAssignments.length === 0 ? (
                                              <div className="flex items-center justify-center h-12 text-center text-gray-400 text-sm border-2 border-dashed border-gray-200 rounded-lg">
                                                <span>Non assignée</span>
                                              </div>
                                            ) : (
                                              principalAssignments.map((assignment) => {
                                                const teacher = teachers.find(t => t.id === assignment.enseignant_id);
                                                return teacher && (



                                                  <div
                                                    key={assignment.id}
                                                    className={`p-2 rounded-lg border flex items-center justify-between transition-all ${isSelectedTeacher(teacher.id)
                                                        ? 'bg-green-100 border-green-400 border-2 shadow-md' // ✅ Highlight pour l'enseignant sélectionné
                                                        : 'bg-green-50 border-green-200'
                                                      }`}
                                                  >
                                                    <div className="flex items-center">
                                                      <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-2 text-xs font-medium ${isSelectedTeacher(teacher.id)
                                                          ? 'bg-green-600 text-white animate-pulse' // ✅ Animation pulse
                                                          : 'bg-green-500 text-white'
                                                        }`}>
                                                        <User size={12} />
                                                      </div>
                                                      <div>
                                                        <div className={`font-medium text-sm ${isSelectedTeacher(teacher.id)
                                                            ? 'text-green-900 font-bold' // ✅ Texte en gras pour l'enseignant sélectionné
                                                            : 'text-gray-800'
                                                          }`}>
                                                          {teacher.nom} {teacher.prenom}
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <button
                                                      onClick={() => {
                                                        setConfirmDialog({
                                                          isOpen: true,
                                                          teacher: teacher,
                                                          class: classItem,
                                                          type: 'remove-principal',
                                                          assignmentId: assignment.id,
                                                          description: `Supprimer l'affectation de ${teacher.prenom} ${teacher.nom} comme enseignant principal de la classe ${classItem.nom} ?`,
                                                          subjects: [],
                                                          subject: null
                                                        });
                                                      }}
                                                      className="text-red-500 hover:text-red-700 transition-colors"
                                                    >
                                                      <Trash2 className="h-4 w-4" />
                                                    </button>
                                                  </div>


                                                );
                                              })
                                            )}
                                          </div>

                                          {/* Enseignants de matiÃÂ¨re */}
                                          <div>
                                            <div className="text-xs font-medium text-gray-500 mb-2 flex items-center">
                                              <GraduationCap size={12} className="mr-1" />
                                              Enseignants de matière ({subjectCount})
                                            </div>

                                            {subjectAssignments.length === 0 ? (
                                              <div className="flex items-center justify-center h-12 text-center text-gray-400 text-sm border-2 border-dashed border-gray-200 rounded-lg">
                                                <span>Aucune matière assignée</span>
                                              </div>
                                            ) : (
                                              <div className="space-y-1 max-h-32 overflow-y-auto">
                                                {(() => {
                                                  // Grouper par enseignant
                                                  const teacherSubjects = {};
                                                  subjectAssignments.forEach(assignment => {
                                                    const teacher = teachers.find(t => t.id === assignment.enseignant_id);
                                                    // Ã¢ÂÂ CORRECTION : RÃÂ©cupÃÂ©rer la matiÃÂ¨re depuis l'assignment directement
                                                    const subjectName = assignment.matiere_nom || assignment.subject_name || 'MatiÃÂ¨re inconnue';

                                                    if (teacher) {
                                                      if (!teacherSubjects[teacher.id]) {
                                                        teacherSubjects[teacher.id] = {
                                                          teacher: teacher,
                                                          subjects: [],
                                                          assignmentIds: []
                                                        };
                                                      }
                                                      teacherSubjects[teacher.id].subjects.push({
                                                        id: assignment.matiere_id,
                                                        nom: subjectName
                                                      });
                                                      teacherSubjects[teacher.id].assignmentIds.push(assignment.id);
                                                    }
                                                  });

                                                  return Object.values(teacherSubjects).map(({ teacher, subjects, assignmentIds }) => (


                                                    <div
                                                      key={teacher.id}
                                                      className={`p-2 rounded-lg border transition-all ${isSelectedTeacher(teacher.id)
                                                          ? 'bg-blue-100 border-blue-400 border-2 shadow-md' // ✅ Highlight pour l'enseignant sélectionné
                                                          : 'bg-blue-50 border-blue-200'
                                                        }`}
                                                    >
                                                      <div className="flex items-center justify-between">
                                                        <div className="flex items-center flex-1">
                                                          <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-2 text-xs font-medium ${isSelectedTeacher(teacher.id)
                                                              ? 'bg-blue-600 text-white animate-pulse' // ✅ Animation pulse
                                                              : 'bg-blue-500 text-white'
                                                            }`}>
                                                            <User size={12} />
                                                          </div>
                                                          <div className="flex-1 min-w-0">
                                                            <div className={`font-medium text-sm truncate ${isSelectedTeacher(teacher.id)
                                                                ? 'text-blue-900 font-bold' // ✅ Texte en gras pour l'enseignant sélectionné
                                                                : 'text-gray-800'
                                                              }`}>
                                                              {teacher.nom} {teacher.prenom}
                                                            </div>
                                                            <div className="text-xs text-gray-500">
                                                              {subjects.map(s => s.nom).join(', ')}
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="flex gap-1">
                                                          {assignmentIds.map((assignmentId, index) => (
                                                            <button
                                                              key={assignmentId}
                                                              onClick={() => {
                                                                setConfirmDialog({
                                                                  isOpen: true,
                                                                  teacher: teacher,
                                                                  class: classItem,
                                                                  subject: subjects[index],
                                                                  type: 'remove-subject',
                                                                  assignmentId: assignmentId,
                                                                  description: `Supprimer l'affectation de ${teacher.prenom} ${teacher.nom} pour la matière ${subjects[index].nom} dans la classe ${classItem.nom} ?`,
                                                                  subjects: []
                                                                });
                                                              }}
                                                              className="text-red-500 hover:text-red-700 transition-colors"
                                                              title={`Supprimer ${subjects[index].nom}`}
                                                            >
                                                              <Trash2 className="h-3 w-3" />
                                                            </button>
                                                          ))}
                                                        </div>
                                                      </div>
                                                    </div>

                                                  ));
                                                })()}
                                              </div>
                                            )}
                                          </div>




                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    });
                  })()}

                  {/* message quand aucune classe n'est trouvée  */}
                  {filterBySelectedTeacher && selectedTeachers.length > 0 && (() => {
                    const { filteredClasses } = getFilteredSectionsAndClasses();
                    if (filteredClasses.length === 0) {
                      const teacher = teachers.find(t => t.id === selectedTeachers[0]);
                      return (
                        <div className="flex flex-col items-center justify-center py-12 text-center">
                          <BookOpen size={48} className="text-gray-300 mb-4" />
                          <p className="text-gray-600 font-medium">
                            Aucune affectation trouvée
                          </p>
                          <p className="text-gray-500 text-sm mt-2">
                            {teacher ? `${teacher.prenom} ${teacher.nom}` : 'Cet enseignant'} n'est affecté(e) à aucune classe.
                          </p>
                          <Button
                            size="default"
                            onClick={() => {
                              setFilterBySelectedTeacher(false);
                              setSelectedTeachers([]);
                            }}
                            className="mt-4 bg-[#246990] text-white hover:bg-[#3084b5]"
                          >
                            Voir toutes les classes
                          </Button>
                        </div>
                      );
                    }
                    return null;
                  })()}


                </div>
              </div>
            </div>
          </div>
        </>
      )}


      {/* ConfirmDialog */}

      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        onClose={() => {
          if (!isProcessing) { // ✅ Empêcher la fermeture pendant le traitement
            setConfirmDialog({
              isOpen: false,
              teacher: null,
              class: null,
              type: '',
              description: '',
              subjects: [],
              assignmentId: null,
              subject: null
            });
          }
        }}
        onConfirm={handleConfirmation}
        title={
          confirmDialog.type === 'assign-principal' ? 'Affecter enseignant principal' :
            confirmDialog.type === 'assign-subject' ? 'Affecter enseignant de matière' :
              confirmDialog.type === 'remove-principal' ? 'Supprimer enseignant principal' :
                confirmDialog.type === 'remove-subject' ? 'Supprimer affectation matière' :
                  'Confirmation'
        }
        description={confirmDialog.description}
        confirmText={confirmDialog.type?.startsWith('remove') ? 'Supprimer' : 'Confirmer'}
        cancelText="Annuler"
        type={confirmDialog.type?.startsWith('remove') ? 'warning' : 'question'}
        isLoading={isProcessing} // ✅ Passer l'état de chargement
      />



    </div>
  );
};

export default TeacherClassAssignment;
